import { render, staticRenderFns } from "./QRStatus.vue?vue&type=template&id=b1bcd9dc&"
import script from "./QRStatus.vue?vue&type=script&lang=ts&"
export * from "./QRStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports